import { render, staticRenderFns } from "./ACStatisticsCard.vue?vue&type=template&id=bede950a"
import script from "./ACStatisticsCard.vue?vue&type=script&lang=js"
export * from "./ACStatisticsCard.vue?vue&type=script&lang=js"
import style0 from "./ACStatisticsCard.vue?vue&type=style&index=0&id=bede950a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports